export default (numberOfJobs, theme) => ({
  bottomCart: false,
  numberOfJobs,
  theme,

  quickSearch() {
    Turbo.visit('/search')
  },
})
